import React from 'react';
import { MdLockOutline } from 'react-icons/md';

const LockedIcon = () => (
  <div className="evie-my-program__infocontent_lock">
    <MdLockOutline />
  </div>
);

export default LockedIcon;
